export enum SettingsType {
    AUDIO = 'audio',
    VIDEO = 'video'
}


export const Resolutions = [
    { id: 0, value: 'Automatic', title: 'Automatic', selected: true },
    { id: 1, value: '720p', title: '720p', selected: false },
    { id: 2, value: '540p', title: '540p', selected: false },
    { id: 3, value: '480p', title: '480p', selected: false },
    { id: 4, value: '360p', title: '360p', selected: false },
  ];

export const DefaultResolution =
    Resolutions.find(resolution => resolution.selected)?.value ?? Resolutions[0].value;